export default __webpack_public_path__ + "static/media/logout.b5e1503b.svg";